import { render, staticRenderFns } from "./SDCampiagnViewSettings.vue?vue&type=template&id=42821892&scoped=true"
import script from "./SDCampiagnViewSettings.vue?vue&type=script&lang=js"
export * from "./SDCampiagnViewSettings.vue?vue&type=script&lang=js"
import style0 from "./SDCampiagnViewSettings.vue?vue&type=style&index=0&id=42821892&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42821892",
  null
  
)

export default component.exports